"use strict";

var _defineProperty = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$DENTAL_TEMPL;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var scenario_state_1 = require("../../redux/scenario/scenario.state");
/***************************************
 * TEMPLATE
 ***************************************/

/*
  挿入対象の nodeMap
  user が選択した不必要な node, option を削除したのち、親元の nodeMap と merge する
 */
//TODO id を 20 桁に


exports.DENTAL_TEMPLATE_TOP_ID = 'DENTAL_TEMPLATE_TOP';
exports.DENTAL_TEMPLATE = (_exports$DENTAL_TEMPL = {}, _defineProperty(_exports$DENTAL_TEMPL, exports.DENTAL_TEMPLATE_TOP_ID, {
  header: 'どのような症状でお悩みですか？',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'TEMAzYAF3Acp',
    actionUrl: null,
    label: '歯が痛い/染みる'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'GC23iU159JJb',
    actionUrl: null,
    label: '歯ぐきから血が出る/腫れている'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'NxOKmV4f9KOQ',
    actionUrl: null,
    label: '歯が抜けた/失った'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'ysEsFYE1Benb',
    actionUrl: null,
    label: 'ケガをした'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: '8AQtV6PgGpCN',
    actionUrl: null,
    label: '見た目を綺麗にしたい'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'CtP9JhQ5ioox',
    actionUrl: null,
    label: 'その他'
  }],
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, '343ZJBBhBzv8', {
  header: '慢性的な病気によってもたらされる口臭です。\n\n・進行した虫歯や歯周病\n・口呼吸や、胃腸・糖尿病などの内科的病気\n\nが主な原因です。',
  options: [],
  parentId: '3J11uLaTchBn',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "G5sxF4n830z4", {
  header: '歯科医院の診療室で、歯科医師によって行われる方法です。\n効果がすぐに現れるので、早く・楽に歯を白くしたい方におすすめです。\n\n〈特徴〉\n・効果がすぐに現れる\n・比較的色がもとに戻りやすい\n・歯科医師に直接治療してもらえるので安心',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: 'カウンセリングを受けてみる'
  }],
  parentId: 'MATuTCJHnwP1',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "rSey9bAKnJNL", {
  header: 'すきっ歯には、通常矯正治療を行います。\nまた、詰め物や被せ物で治療を行うこともできるので、患者様の予算に合わせた治療をご相談させてください。',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'd5VnVsGgleJ8',
    actionUrl: null,
    label: '矯正歯科について'
  }, {
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: 'カウンセリング予約'
  }],
  parentId: '8AQtV6PgGpCN',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "J2RFsJdePtDo", {
  header: 'インプラント治療とは、人工の歯根を、歯を失った箇所に埋め込む治療法です。\n\nこれまでは、入れ歯やブリッジを選択することが一般的でしたが、近年インプラント治療を希望する患者さんが増えてきております。\n\nインプラントはブリッジと比べて、周囲の歯にかかる負担が少なく独立した歯として機能するので周りの歯を傷めずに済みます。\nまた、通常の歯と同じように顎に力が伝わるため、骨の変形も少なくて済みます。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '【ご予約はこちらから】'
  }],
  parentId: 'CkMaaFobkEpY',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "Ie5XJPJFqy1k", {
  header: '口臭の原因の70％を占める口臭です。\n起床時や妊娠時、更年期など唾液の分泌やホルモンの変化によってもたらされる口臭が当てはまります。',
  options: [],
  parentId: '3J11uLaTchBn',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "zTX2BUrZiXk0", {
  header: '歯を白くする方法は大きく分けて3つ\n\n①クリーニングで歯石や歯垢を除去して歯の本来の白さを取り戻す。\n②ホワイトニングでクリーニングでは取れない着色を除去する\n\n歯の状態によって適切な治療は異なります。\nホワイトニングのご相談も受け付けております！',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: 'カウンセリングを受けてみる'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: '90JoN5wympEA',
    actionUrl: null,
    label: 'ホワイトニングに関して'
  }],
  parentId: '8AQtV6PgGpCN',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "HtJev3jpOSYn", {
  header: '当院ではマウスピース矯正に力を入れて取り組んでいます。\nマウスピース矯正とはインビザラインとも言われ、その名の通り取り外し式のマウスピースで徐々に歯並びを整えていく治療法です。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: 'カウンセリング予約'
  }],
  parentId: 'saNdiPucO7oc',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "TVaN9iyuPoNw", {
  header: '口臭治療では原因を突き止め、その原因を解決することが最も重要です。\nまた、原因を突き止めることで適切な治療やケアが見つかります。',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'ztRNovGp4fIh',
    actionUrl: null,
    label: '①虫歯や歯周病の治療'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'oKlWl46vLjTW',
    actionUrl: null,
    label: '②定期検診による予防'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'laPaF7NLoUda',
    actionUrl: null,
    label: '③生活習慣の改善'
  }],
  parentId: 'hBYQP7l8lOa7',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "LKuN6c67jdqU", {
  header: '詰め物を変えてみることで目立つ銀歯を治すことができます。',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'SKME1jqfFYts',
    actionUrl: null,
    label: '被せ物の種類'
  }, {
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '予約する'
  }],
  parentId: '8AQtV6PgGpCN',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "ilIIoj4hCYqm", {
  header: '【インレー】詰め物',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    imageName: '新しい選択肢',
    imageUrl: '【インレー】詰め物.jpg',
    explanation: '歯の「詰め物」として知られています。\n小さい虫歯を削った箇所に詰め物(インレー)を詰め、治療を終了します。\n\n保険適用の銀歯から、自然の歯により近い色を再現できる素材まで様々ございますので、患者様のご予算に合わせてご提案させていただきます。'
  }],
  parentId: 'UvirsytZESWo',
  type: scenario_state_1.ScenarioNodeType.ImageExplanation
}), _defineProperty(_exports$DENTAL_TEMPL, '90JoN5wympEA', {
  header: 'ホワイトニングにはホームホワイトニングとオフィスホワイトニングがあります',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: '6kVoYbZAAdF3',
    actionUrl: null,
    label: 'ホームホワイトニング'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'hHlNK6tNdvfj',
    actionUrl: null,
    label: 'オフィスホワイトニング'
  }],
  parentId: 'zTX2BUrZiXk0',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "qMstmGJxJqYQ", {
  header: '補綴物の種類',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'Ckp10FUCht3o',
    actionUrl: null,
    imageName: '新しい選択肢',
    imageUrl: '【インレー】詰め物',
    explanation: '歯の「詰め物」として知られています。\n小さい虫歯を削った箇所に詰め物(インレー)を詰め、治療を終了します。\n\n保険適用の銀歯から、自然の歯により近い色を再現できる素材まで様々ございますので、患者様のご予算に合わせてご提案させていただきます。'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'TgqAGAKSVl2t',
    actionUrl: null,
    imageName: '新しい選択肢',
    imageUrl: '【クラウン】被せ物',
    explanation: '歯の「かぶせ物」として知られてます。\n歯の欠損した部分を補修仕切れない際に歯全体を冠として覆うために使われます。\n\nこちらも詰め物と同じく、素材が複数ございます。'
  }],
  parentId: 'wXSYLLLjBy9u',
  type: scenario_state_1.ScenarioNodeType.ImageExplanation
}), _defineProperty(_exports$DENTAL_TEMPL, "TEMAzYAF3Acp", {
  header: '虫歯の進行状態を確認します。\n\n現在どのような状態が最もあてはまりますか？\n虫歯の原因や、予防の方法についてもお教えします！',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'yBUBWyl1aJvL',
    actionUrl: null,
    label: '冷たいものが染みる'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'wXSYLLLjBy9u',
    actionUrl: null,
    label: 'ひどく痛む'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'CkMaaFobkEpY',
    actionUrl: null,
    label: '歯がほとんど残っていない'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'cQVuHXmUyPnM',
    actionUrl: null,
    label: '虫歯の原因って？'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'yBoOvwsu4jul',
    actionUrl: null,
    label: '予防の方法について'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: '0LjKmQWt2Szl',
    actionUrl: null,
    label: '虫歯の進行について'
  }],
  parentId: exports.DENTAL_TEMPLATE_TOP_ID,
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "jGeUdbJgpJQ4", {
  header: '[画像シナリオ]',
  options: [],
  parentId: 'b25R9U1FmfA3',
  type: scenario_state_1.ScenarioNodeType.Image
}), _defineProperty(_exports$DENTAL_TEMPL, "Aomimnzj0WNs", {
  header: '歯科医師の指導の元に、専用マウスピースを作成し、ご自宅で行って頂く方法が『ホームホワイトニング』です。\n歯の黄ばみが気になる方、クリーニングでは除去できない色素が沈着している方に適しています。\n\n〈特徴〉\n・効果はゆっくりと現れる\n・元に戻りにくく、白さが持続する',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: 'カウンセリングを受けてみる'
  }],
  parentId: 'MATuTCJHnwP1',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "EGPYxSrjjKZc", {
  header: '最も有用な予防は、やはりしっかりと歯を磨くことです。食後の丁寧なブラッシングで口の中を清潔に保ちましょう。\n\n磨き方にも注意をしてください。\n噛み合わせの溝の部分は歯垢が付着しやすく、取りにくいです。ブラッシングで届かない部分はデンタルフロス/歯間ブラシなどを活用して磨き残しのないようにしましょう。',
  options: [],
  parentId: 'yBoOvwsu4jul',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, '7uzqDxPtOkqQ', {
  header: '虫歯菌の中でも最も悪い菌を”ミュータンス菌” といいます。\n生後36ヶ月までの間に母親から感染しやすく、一旦感染してしまうとなかなか菌の量を減らすことができません。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '【ご予約はこちらから】'
  }],
  parentId: 'cQVuHXmUyPnM',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "HfWcQ1QBr3G4", {
  header: '説明文を入力',
  options: [],
  parentId: 'b25R9U1FmfA3',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "Jyjb3F1tc5Ql", {
  header: '継続的に間食を取ると口の中が常に不衛生な状態になりやすくなります。間食をする場合は、食後にすぐに歯を磨きましょう。 睡眠中は唾液の量が減少し、虫歯菌が繁殖しやすい状態になります。寝てる間に虫歯菌に栄養を与える事になってしまうので、就寝直前の飲食は控えましょう。',
  options: [],
  parentId: 'yBoOvwsu4jul',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "CtP9JhQ5ioox", {
  header: '選択して下さい',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'hBYQP7l8lOa7',
    actionUrl: null,
    label: '口臭が気になる'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'mBqPKkvVlPLp',
    actionUrl: null,
    label: '治療後の痛みが気になる'
  }],
  parentId: exports.DENTAL_TEMPLATE_TOP_ID,
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "kMCGEG6M5SWE", {
  header: '詰め物／被せ物を行います。\n\n欠損部分の状態に応じて治療が変わりますので、まずはご相談ください！',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: 'ご予約はこちらから'
  }],
  parentId: 'ysEsFYE1Benb',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, '33X8Cjzc5HzC', {
  header: '歯の黄ばみや汚れを取るために、まずは汚れの原因を突き止める必要があります。\n\n歯垢や歯石が原因の着色であればクリーニングで元の歯の色へ戻せるかもしれません。\n\nコーヒーの色素や沈着してしまっている場合や加齢による黄ばみの場合はホワイトニングで白い歯を取り戻せます。\n\n患者様に合った治療をご提案させて頂きますので、まずはお気軽にご相談ください',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'MATuTCJHnwP1',
    actionUrl: null,
    label: 'ホワイトニングについて'
  }, {
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: 'カウンセリングを受けてみる'
  }],
  parentId: '8AQtV6PgGpCN',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "MATuTCJHnwP1", {
  header: '歯を白くする方法は大きく分けて3つ\n\n①クリーニングで歯石や歯垢を除去して歯の本来の白さを取り戻す。\n②ホワイトニングでクリーニングでは取れない着色を除去する\n\n歯の状態によって適切な治療は異なります。\nホワイトニングのご相談も受け付けております！',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'Aomimnzj0WNs',
    actionUrl: null,
    label: 'ホームホワイトニング'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'G5sxF4n830z4',
    actionUrl: null,
    label: 'オフィスホワイトニング'
  }],
  parentId: '33X8Cjzc5HzC',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "NxqHAFunS5JU", {
  header: '説明文を入力',
  options: [],
  parentId: 'b25R9U1FmfA3',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, '19QT2FVWALoQ', {
  header: '歯ぐきから血が出るのは歯周病のサイン\n成人の約8割が歯周病に罹っているという統計があります。\n\n下記のような症状も歯周病のサインです！\n\n・歯に食べ物が挟まりやすくなった\n・朝、口の中がネバネバする\n・歯が長くなったように感じる\n・口臭があるとよくいわれる\n\n少しでも心当たりのある方、まずはご相談ください！',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: 'ご予約はこちらから'
  }],
  parentId: 'GC23iU159JJb',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "d5VnVsGgleJ8", {
  header: '当院では、マウスピース矯正で矯正治療を行うことが出来ます。',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'aSMT9fEhFjBs',
    actionUrl: null,
    label: 'マウスピース矯正とは'
  }],
  parentId: 'rSey9bAKnJNL',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, '71iA2dfmqvrO', {
  header: '歯を失った箇所の両脇の歯を支えにして、人口の補綴物を橋のように架けるものをブリッジといいます。\n\n入れ歯よりも違和感なく噛むことができる反面、歯を削る量は多くなってしまいます。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '【ご予約はこちらから】'
  }],
  parentId: 'NxOKmV4f9KOQ',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "TQ8sWIpkTWGl", {
  header: '親知らずの放置は以下の様なリスクに繋がります。\n\n・虫歯や歯周病になりやすい\n・歯並びへの影響\n・感染症\nに繋がる恐れも…\n\n生えている向きによっては、このような症状を誘発させます。\n場合によっては大臼歯(奥歯)の歯の根を溶かすことも御座います。\nこのようなことを未然に防ぐために、抜歯が必要な場合が御座います。\n親知らずの状態によって必要な治療が変わりますので、一度ご相談ください。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '【ご予約はこちらから】'
  }],
  parentId: 'wXSYLLLjBy9u',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, '6kVoYbZAAdF3', {
  header: '歯科医師の指導の元に、専用マウスピースを作成し、ご自宅で行って頂く方法が『ホームホワイトニング』です。\n歯の黄ばみが気になる方、クリーニングでは除去できない色素が沈着している方に適しています。\n\n〈特徴〉\n・効果はゆっくりと現れる\n・元に戻りにくく、白さが持続する',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: 'ご予約はこちらから'
  }],
  parentId: '90JoN5wympEA',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, '6X0D2fo2HfsW', {
  header: '歯磨きやうがいが不十分なときや、歯の磨き方が間違っている場合、口の中に食べかすや糖質が残ってしまいます。虫歯菌がこれらの食べかすを歯に付着させ、虫歯を作ります。\n\n間食が多く、いつも口の中に食べかすがあったり、歯磨きやうがいが不十分だったり、あるいは間違った方法で歯磨きをしていると、口の中に糖質や食べかすが残ります。歯垢の中にいる虫歯菌が、これらをのり状の酸につくり変えて歯の表面に付着させるので、虫歯ができやすくなります。とくに、砂糖の入った甘い食べ物は、虫歯菌が酸をつくりやすいので、虫歯の大きな原因となります。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '【ご予約はこちらから】'
  }],
  parentId: 'cQVuHXmUyPnM',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "oKlWl46vLjTW", {
  header: '加齢と共に唾液の分泌量が減り、口内環境の維持が難しくなっていきます。自分だけでは磨き残しができやすいので、定期的な検診を受けて口内環境を清潔に保ちましょう。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '口臭の原因を検査してみる'
  }],
  parentId: 'TVaN9iyuPoNw',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, '9vQwDJMCw6qC', {
  header: '進行した虫歯は自然に治ることがありません。\nまた、初期の虫歯は患者さんご自身で発見することができません。\nそのため、年に1回〜3回は歯科医院で定期検診を受けましょう。',
  options: [],
  parentId: 'yBoOvwsu4jul',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "SKME1jqfFYts", {
  header: '補綴物の種類',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    imageName: '新しい選択肢',
    imageUrl: '【インレー】詰め物',
    explanation: '歯の「詰め物」として知られています。\n小さい虫歯を削った箇所に詰め物(インレー)を詰め、治療を終了します。\n\n保険適用の銀歯から、自然の歯により近い色を再現できる素材まで様々ございますので、患者様のご予算に合わせてご提案させていただきます。'
  }, {
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    imageName: '新しい選択肢',
    imageUrl: '【クラウン】被せ物',
    explanation: '歯の「かぶせ物」として知られてます。\n歯の欠損した部分を補修仕切れない際に歯全体を冠として覆うために使われます。\n\nこちらも詰め物と同じく、素材が複数ございます。'
  }],
  parentId: 'LKuN6c67jdqU',
  type: scenario_state_1.ScenarioNodeType.ImageExplanation
}), _defineProperty(_exports$DENTAL_TEMPL, "YqmFjcwGFwou", {
  header: '歯がグラグラする場合は骨折が疑われます。\n\nまた、特に外部からの衝撃を受けたわけではないのに歯がグラグラする場合には歯周病に罹っている可能性があります。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: 'ご予約はこちらから'
  }],
  parentId: 'ysEsFYE1Benb',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, '0LjKmQWt2Szl', {
  header: '虫歯の進行について',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    imageName: '新しい選択肢',
    imageUrl: 'C0',
    explanation: '表面が白く濁ったり茶色くなる虫歯の初期状態です。\n表面が浅く溶けた状態で、この段階では削らず経過観察となります。'
  }, {
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    imageName: '新しい選択肢',
    imageUrl: 'C1',
    explanation: '自覚症状はなく、歯科医院を受診することで発見されます。\nエナメル質というはの表面が侵される状態で最小限に歯を削ります。\n\nまた、場合によっては歯を削らずに済む場合もあります。'
  }, {
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    imageName: '新しい選択肢',
    imageUrl: 'C2',
    explanation: '虫歯がエナメル質の奥の象牙質まで進行している状態です。\n始めは冷たいもの、進行すると熱いものがしみるようになり、ズキズキと痛みます。\n\n歯を大きく削る治療を行います。'
  }, {
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    imageName: '新しい選択肢',
    imageUrl: 'C3',
    explanation: '虫歯が神経(歯髄)に到達している場合は、神経の除去または除菌が必要になります。\n炎症が進行すると歯髄が腐ってしまいます。\n\n歯を残すために、根っこの部分を治療します。\n最後に被せ物(クラウン)を被せて治療は完了です。\n治療回数は５～６回かかります。\n'
  }, {
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    imageName: '新しい選択肢',
    imageUrl: 'C4',
    explanation: '歯髄(神経) は死んでしまっており、痛みはありません。\n通常ここまできた歯を残すことはできませんが、状態によっては残す治療も可能かもしれません。\n\nお気軽にご相談ください！'
  }],
  parentId: 'TEMAzYAF3Acp',
  type: scenario_state_1.ScenarioNodeType.ImageExplanation
}), _defineProperty(_exports$DENTAL_TEMPL, '5e7MJbnvbMrS', {
  header: '【クラウン】被せ物',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    imageName: '新しい選択肢',
    imageUrl: 'クラウン.jpg',
    explanation: '歯の「かぶせ物」として知られてます。\n歯の欠損した部分を補修仕切れない際に歯全体を冠として覆うために使われます。\n\n\nこちらも詰め物と同じく、素材が複数ございます。'
  }],
  parentId: 'UvirsytZESWo',
  type: scenario_state_1.ScenarioNodeType.ImageExplanation
}), _defineProperty(_exports$DENTAL_TEMPL, '1JvZLiKXb7Lb', {
  header: '永久歯が生え揃う7〜8歳頃にカルシウムなどの必要な栄養素が不足すると、エナメル質と呼ばれる歯の表面を覆う部分が完全に形成されず、虫歯になりやすい質の歯になってしまいます。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '【ご予約はこちらから】'
  }],
  parentId: 'cQVuHXmUyPnM',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, '3J11uLaTchBn', {
  header: '口臭の原因は3つあります。',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'Ie5XJPJFqy1k',
    actionUrl: null,
    label: '生理的口臭'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: '343ZJBBhBzv8',
    actionUrl: null,
    label: '病的口臭'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'RWsllcqCwVIz',
    actionUrl: null,
    label: '外因的口臭'
  }],
  parentId: 'hBYQP7l8lOa7',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "XGjcukBvhNJF", {
  header: '歯並びを良くするためには、矯正治療を行います。',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'saNdiPucO7oc',
    actionUrl: null,
    label: '矯正歯科について'
  }, {
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '問い合わせ'
  }],
  parentId: '8AQtV6PgGpCN',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "NxOKmV4f9KOQ", {
  header: '歯を失ってしまったら、その部分を治療しなくてはいけません。\n\nそのままにしてしまうと、噛み合わせが悪くなってしまったり、歯が動いてしまったりという影響も、、、\n\n治療にも様々御座いますので、ご相談に応じて患者様に適した治療を行わせて頂きます。',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: '71iA2dfmqvrO',
    actionUrl: null,
    label: 'ブリッジ'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'HEsQvlOQM16v',
    actionUrl: null,
    label: 'インプラント'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'w1h8hKSauQfN',
    actionUrl: null,
    label: '入れ歯'
  }],
  parentId: exports.DENTAL_TEMPLATE_TOP_ID,
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "Ckp10FUCht3o", {
  header: '説明文を入力',
  options: [],
  parentId: 'qMstmGJxJqYQ',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "saNdiPucO7oc", {
  header: '当院では、マウスピース矯正で矯正治療を行うことが出来ます。',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'HtJev3jpOSYn',
    actionUrl: null,
    label: 'マウスピース矯正とは'
  }],
  parentId: 'XGjcukBvhNJF',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "dNBZFprVg9Dw", {
  header: '歯を打つなど、なんらかの刺激があった後、歯の色が変わってくることがあります。\n\n直後の変色は神経の中の血管が損傷したことによる充血と考えられますが、数ヶ月して徐々に歯の色が黒ずんでくる場合は神経が死んでしまっている可能性が高くなります。\n\nそこから更に歯肉が腫れてきたりすることもあるので、定期的に検査を行い、根の周囲の変化/病気に早く気付ける環境にしておきましょう。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: 'ご予約はこちらから'
  }],
  parentId: 'ysEsFYE1Benb',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "GC23iU159JJb", {
  header: '歯ぐきから血が出る場合、原因のほとんどが歯肉炎や歯周病です。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: 'ご予約はこちらから'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: '19QT2FVWALoQ',
    actionUrl: null,
    label: '歯周病について'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'NA4fUoVThnhD',
    actionUrl: null,
    label: '歯周病の進行'
  }],
  parentId: exports.DENTAL_TEMPLATE_TOP_ID,
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "CkMaaFobkEpY", {
  header: '歯髄(神経) は死んでしまっており、痛みはありません。\n通常ここまできた歯を残すことはできませんが、状態によっては残す治療も可能かもしれません。\n\nお気軽にご相談ください！',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '【ご予約はこちらから】'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'J2RFsJdePtDo',
    actionUrl: null,
    label: 'インプラント治療について'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'UvirsytZESWo',
    actionUrl: null,
    label: '被せ物の種類'
  }],
  parentId: 'TEMAzYAF3Acp',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "ztRNovGp4fIh", {
  header: '虫歯や歯周病にかかりやすい方は、口臭も発生しやすくなります。虫歯や歯周病がある場合は早急にしっかりと治療しておきましょう。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '口臭の原因を検査してみる'
  }],
  parentId: 'TVaN9iyuPoNw',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "RWsllcqCwVIz", {
  header: '体の外に原因がある口臭で、\n\n・にんにくやネギなどの飲食による口臭\n・喫煙や飲酒による口臭\n\nが主な原因です。',
  options: [],
  parentId: '3J11uLaTchBn',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, '8AQtV6PgGpCN', {
  header: 'どのようなところが気になりますか？',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'zTX2BUrZiXk0',
    actionUrl: null,
    label: '歯を白くしたい'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'LKuN6c67jdqU',
    actionUrl: null,
    label: '銀歯を直したい'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'rSey9bAKnJNL',
    actionUrl: null,
    label: 'すきっ歯を直したい'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'XGjcukBvhNJF',
    actionUrl: null,
    label: '歯並びをキレイにしたい'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: '33X8Cjzc5HzC',
    actionUrl: null,
    label: '歯の黄ばみや汚れをとりたい'
  }],
  parentId: exports.DENTAL_TEMPLATE_TOP_ID,
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "HEsQvlOQM16v", {
  header: 'インプラント治療とは、人工の歯根を、歯を失った箇所に埋め込む治療法です。\n\nこれまでは、入れ歯やブリッジを選択することが一般的でしたが、近年インプラント治療を希望する患者さんが増えてきております。\n\nインプラントはブリッジと比べて、周囲の歯にかかる負担が少なく独立した歯として機能するので周りの歯を傷めずに済みます。\nまた、通常の歯と同じように顎に力が伝わるため、骨の変形も少なくて済みます。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '【ご予約はこちらから】'
  }],
  parentId: 'NxOKmV4f9KOQ',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "wXSYLLLjBy9u", {
  header: '虫歯が神経(歯髄)に到達している場合は、神経の除去または除菌が必要になります。\n炎症が進行すると歯髄が腐ってしまいます。\n\n歯を残すために、根っこの部分を治療します。\n最後に被せ物(クラウン)を被せて治療は完了です。\n治療回数は５～６回かかります。\n\nまた、奥歯が痛む場合は親知らずが原因になっている可能性もあります。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '【ご予約はこちらから】'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'qMstmGJxJqYQ',
    actionUrl: null,
    label: '被せ物の種類'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'TQ8sWIpkTWGl',
    actionUrl: null,
    label: '親知らずについて'
  }],
  parentId: 'TEMAzYAF3Acp',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "laPaF7NLoUda", {
  header: '日常生活の改善により口臭を抑えられることもよくあります。\n臭いの強い食品は避ける・毎食後の歯磨きを怠らないなど、少しの工夫で臭いの発生を防ぐことができます。\nまた緑茶や牛乳を飲むのも効果的です。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '口臭の原因を検査してみる'
  }],
  parentId: 'TVaN9iyuPoNw',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "yBoOvwsu4jul", {
  header: '虫歯を予防するために・・・',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'EGPYxSrjjKZc',
    actionUrl: null,
    label: '①歯を丁寧に磨く/フロスを活用する'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'Jyjb3F1tc5Ql',
    actionUrl: null,
    label: '②間食は× 、就寝直前の飲食は控えましょう'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: '9vQwDJMCw6qC',
    actionUrl: null,
    label: '③歯科医院で定期的に検診を受ける'
  }],
  parentId: 'TEMAzYAF3Acp',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "epzCjr5JrWrU", {
  header: '唾液には表面を多って歯を守る働きがあります。\nその他にも虫歯菌に対抗して酸を中和する働きもあるため、口の中が乾燥して唾液が減少すると虫歯のリスクが高まります。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '【ご予約はこちらから】'
  }],
  parentId: 'cQVuHXmUyPnM',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "cQVuHXmUyPnM", {
  header: '約90％の日本人が虫歯にかかっています。\n一度虫歯になってしまうと、治療しなければ元に戻りません。\n\nまずは虫歯の原因を知り、予防を心がけることで歯の健康を守り続けましょう。\n\n【虫歯を作る4条件】',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: '6X0D2fo2HfsW',
    actionUrl: null,
    label: '①口の中の糖質や食べ残し'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: '1JvZLiKXb7Lb',
    actionUrl: null,
    label: '②歯の質'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: '7uzqDxPtOkqQ',
    actionUrl: null,
    label: '③口の中の菌の量'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'epzCjr5JrWrU',
    actionUrl: null,
    label: '④唾液の量(口が乾きやすいか)'
  }],
  parentId: 'TEMAzYAF3Acp',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "NSJsmp1460CP", {
  header: '歯ぎしりには大きく３つのタイプがあります。\n\n1．歯を強くこすり合わせるタイプ\n2．音を立てずに強く噛み締めるタイプ\n3．上下の歯をカチカチとぶつけるタイプ\n\n歯ぎしり自体はそんなに珍しい行為ではないですが、常習化すると歯や歯茎に悪影響が及んできます。\n\nひどい場合には顎に障害をもたらしたり、睡眠時無呼吸症候群の要因になる場合も。。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: 'ご予約はこちらから'
  }],
  parentId: 'ysEsFYE1Benb',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "mBqPKkvVlPLp", {
  header: '治療後の歯の痛みは、歯の構造に起因しているものなので、しばらくすると痛みは自然と回復致します。\n\n歯を削った後は治療前よりも歯と神経が近い状態になります。\nその分神経へ刺激が伝わりやすくなっていることが治療後に歯がしみたりする原因です。\n\nただし、歯は神経を守ろうと歯と神経の間に”第二象牙質”を作ります。これにより、徐々に痛みはなくなっていきます。',
  options: [],
  parentId: 'CtP9JhQ5ioox',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "yBUBWyl1aJvL", {
  header: 'エナメル質という歯の表面が侵される初期症状の虫歯の場合、歯を削らずに済む可能性があります。\n\n象牙質近くまで進行して虫歯が横に広がっている場合は、すこし大きく削ることになります。',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: '4PVdR9B4yPR5',
    actionUrl: null,
    label: '【ご予約はこちらから】'
  }],
  parentId: 'TEMAzYAF3Acp',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "THHbRITlVAwk", {
  header: '説明文を入力',
  options: [],
  parentId: 'b25R9U1FmfA3',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "UvirsytZESWo", {
  header: '補綴物の種類',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'ilIIoj4hCYqm',
    actionUrl: null,
    label: '【インレー】詰め物'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: '5e7MJbnvbMrS',
    actionUrl: null,
    label: '【クラウン】被せ物'
  }],
  parentId: 'CkMaaFobkEpY',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "IelR8oD6SRDw", {
  header: '説明文を入力',
  options: [],
  parentId: 'b25R9U1FmfA3',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "TgqAGAKSVl2t", {
  header: '[画像説明シナリオ]',
  options: [],
  parentId: 'qMstmGJxJqYQ',
  type: scenario_state_1.ScenarioNodeType.ImageExplanation
}), _defineProperty(_exports$DENTAL_TEMPL, "hHlNK6tNdvfj", {
  header: '歯科医院の診療室で、歯科医師によって行われる方法です。\n効果がすぐに現れるので、早く・楽に歯を白くしたい方におすすめです。\n\n〈特徴〉\n・効果がすぐに現れる\n・比較的色がもとに戻りやすい\n・歯科医師に直接治療してもらえるので安心',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: 'ご予約はこちらから'
  }],
  parentId: '90JoN5wympEA',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, '4PVdR9B4yPR5', {
  header: '説明文を入力',
  options: [],
  parentId: 'yBUBWyl1aJvL',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "aSMT9fEhFjBs", {
  header: '当院ではマウスピース矯正に力を入れて取り組んでいます。\nマウスピース矯正とはインビザラインとも言われ、その名の通り取り外し式のマウスピースで徐々に歯並びを整えていく治療法です。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: 'カウンセリング予約'
  }],
  parentId: 'd5VnVsGgleJ8',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "ysEsFYE1Benb", {
  header: 'どのようなケガですか？',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'kMCGEG6M5SWE',
    actionUrl: null,
    label: '歯が抜けた/欠けた'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'YqmFjcwGFwou',
    actionUrl: null,
    label: '歯がグラグラする/動く'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'dNBZFprVg9Dw',
    actionUrl: null,
    label: '歯が変色した/腫れた'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'NSJsmp1460CP',
    actionUrl: null,
    label: '歯ぎしり'
  }],
  parentId: exports.DENTAL_TEMPLATE_TOP_ID,
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "hBYQP7l8lOa7", {
  header: '口臭の何についてお悩みですか？？',
  options: [{
    actionType: scenario_state_1.ActionType.Id,
    actionId: '3J11uLaTchBn',
    actionUrl: null,
    label: '口臭の原因'
  }, {
    actionType: scenario_state_1.ActionType.Id,
    actionId: 'TVaN9iyuPoNw',
    actionUrl: null,
    label: '口臭を予防する方法'
  }, {
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '口臭について相談する'
  }],
  parentId: 'CtP9JhQ5ioox',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "w1h8hKSauQfN", {
  header: '口内環境を考慮して、最善の入れ歯(義歯)をお作り致します。',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    label: '【ご予約はこちらから】'
  }],
  parentId: 'NxOKmV4f9KOQ',
  type: scenario_state_1.ScenarioNodeType.Text
}), _defineProperty(_exports$DENTAL_TEMPL, "NA4fUoVThnhD", {
  header: '歯周病の進行',
  options: [{
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    imageName: '新しい選択肢',
    imageUrl: '歯周病初期',
    explanation: '自覚症状はなく、歯肉は歯にしっかりとくっついている状態。'
  }, {
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    imageName: '新しい選択肢',
    imageUrl: '歯肉炎',
    explanation: '歯と歯肉の間に歯垢が溜まって、炎症を起こしている状態。\n\n歯を磨くと出血します。'
  }, {
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    imageName: '新しい選択肢',
    imageUrl: '中等度歯周病',
    explanation: '歯と歯肉の間に深い溝ができ、炎症も広がっている状態。\n\n出血・口臭などの症状があり、歯がグラグラしてきます。'
  }, {
    actionType: scenario_state_1.ActionType.Url,
    actionId: null,
    actionUrl: '',
    imageName: '新しい選択肢',
    imageUrl: '重度歯周病',
    explanation: '歯肉が化膿してしまい、膿がでる。歯を支える骨が溶けてなくなってしまうため、グラグラと動きます。'
  }],
  parentId: 'GC23iU159JJb',
  type: scenario_state_1.ScenarioNodeType.ImageExplanation
}), _exports$DENTAL_TEMPL);